import { LOCALE_META, normalizeLocale, type Direction, type Locale } from '@wikigold/i18n';
export { normalizeLocale };

export function localeFromPath(pathname: string): Locale | null {
  const segment = pathname.split('/').filter(Boolean)[0];
  return segment ? normalizeLocale(segment) === segment ? segment as Locale : null : null;
}

export function stripLocale(pathname: string): string {
  const locale = localeFromPath(pathname);
  if (!locale) return pathname || '/';
  const rest = pathname.slice(locale.length + 1);
  return rest.startsWith('/') ? rest : `/${rest}`;
}

export function localePath(locale: Locale, pathname: string): string {
  const path = stripLocale(pathname);
  const normalized = path === '/' ? '/' : path;
  return `/${locale}${normalized}`;
}

export function directionForLocale(locale: Locale): Direction {
  return LOCALE_META[locale].direction;
}
